import { FormGroup, Label } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';
import AppSidebarFilters, { ResetFiltersButton } from '@Components/app-layout/SidebarFilters';

export default function SidebarFilter() {
  const { definitions: { entityNamePlural, filtersClassName }, filters, state: { setFilters, getFilter } } = useGrid()

  const handleChangeFilters = (key, value) => {
    setFilters(filters => {
      if ((Array.isArray(value) && value.length === 0) || value === null) {
        delete filters[key]
      } else {
        filters[key] = value
      }
      return { ...filters }
    })
  }

  const handleClearFilters = () => {
    setFilters({})
  }

  return <AppSidebarFilters entityName={entityNamePlural} className={filtersClassName}>
    <ResetFiltersButton onReset={handleClearFilters} />
    <div className='col-span-2 mt-4 flex flex-col gap-4'>
      {filters.map(({ label, name, formatValue, Component, onChange, ...props }) => <FormGroup key={label}>
        <Label>{label}</Label>
        <Component
          {...props}
          name={name}
          value={formatValue ? formatValue(getFilter(name)) : getFilter(name)}
          onChange={value => handleChangeFilters(name, onChange ? onChange(value) : value)}
        />
      </FormGroup>)}
    </div>
  </AppSidebarFilters>
}
